import React from 'react';
import type { PercentageBarRiskPropsDTO } from '../../types';
import * as S from './styles';

export function PercentageBarRisk({ risk }: Readonly<PercentageBarRiskPropsDTO>): JSX.Element {
	function getPercentageValue(number?: number): string {
		return !!number ? `${Math.round(number)}%` : '';
	}

	return (
		<S.StyledPercentageDiv>
			<S.CategoryOne percentage={risk[0]?.percentage}>{getPercentageValue(risk[0]?.percentage)}</S.CategoryOne>
			<S.CategoryTwo percentage={risk[1]?.percentage}>{getPercentageValue(risk[1]?.percentage)}</S.CategoryTwo>
			<S.CategoryThree percentage={risk[2]?.percentage}>
				{getPercentageValue(risk[2]?.percentage)}
			</S.CategoryThree>
			<S.CategoryFour percentage={risk[3]?.percentage}>{getPercentageValue(risk[3]?.percentage)}</S.CategoryFour>
		</S.StyledPercentageDiv>
	);
}
